import React, { useEffect, useMemo, useState } from "react";
import { RootState, useAppDispatch, useAppSelector } from "../../../store";
import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
  useSearchParams,
} from "react-router-dom";
import {
  filteredStatusFlow,
  getNextStatus,
  manageOrderTypePermission,
  ORDER_NAXT_STATUS_FLOW,
  OrderStatusEnum,
  OrderStatusLabels,
  OrderStepsEnum,
} from "./orderTypes";
import { getQuotationDetailsAPI } from "../Quotations/quotationApis";
import CustomerDetails from "../Quotations/QuotationDetails/CustomerDetails";
import ProductDetails from "../Quotations/QuotationDetails/ProductDetails";
import ServiceDetails from "../Quotations/QuotationDetails/ServiceDetails";
import OrderInstallationChecklist from "./Components/OrderInstallationChecklist";
import NotesDetails from "../Quotations/QuotationDetails/NotesDetails";
import DesignsDetails from "../Quotations/QuotationDetails/DesignDetails";
import BespokeItemsDetails from "../Quotations/QuotationDetails/BespokeItemsDetails";
import {
  Alert,
  Button,
  Dropdown,
  Grid,
  Menu,
  Skeleton,
  Spin,
  Tabs,
  Tooltip,
  Modal,
  Steps,
  Tag,
} from "antd";
import { svg } from "../../../Assets/svg";
import { MoreOutlined } from "@ant-design/icons";
import ProductionPlanning from "./ProductionPlanning";
import {
  GetOrdersDetailsAPI,
  GetOrderBomAndWarningsAPI,
  Get2BSOrderBomAPI,
  GetOrdersProductionPlanAPI,
} from "../../Redux/orders";
import {
  confirmVariableWarningsAPI,
  getPossibleBomDimensionsAPI,
} from "./orderApis";
import { BtnLoader } from "../../../Components/Components";
import StatusChangeConfirmationModal from "./Components/Modals/StatusChangeConfirmationModal";
import ChangeOrderNumber from "./Components/Modals/ChangeOrderNumber";
import {
  PagePermissionNameData,
  usePermissionsChecker,
} from "../../../helpers/permissionModule";
import { CommonConfirmationModal } from "../../../Components/CommonConfirmationModal";
import FullScreenLoader from "../../Components/FullScreenLoader";
import NoPermissionPage from "../../Components/NoPermissionPage";
import SendMailConfirmationModal from "./Components/Modals/SendMailConfirmationModal";
import DispatchDetailsModal from "./Components/Modals/DispatchDetailsModal";
import PlaningStatusErrorModal from "./Components/Modals/PlaningStatusErrorModal";
import DispatchPlanning from "./Components/DispatchPlanning";
import MezzanineDispatchPlanning from "./Components/MezzanineDispatchPlanning";
import DropTbcWarningModal from "./Components/Modals/DropTbcWarningModal";
import VariableConfirmationModal from "./Components/VariableConfirmationModal";
import Jobs from "./Jobs";
import ImproveProductionPlaning from "./ImproveProductionPlaning";
import { getDecryptedUserData } from "../../../helpers/bycrypt";
import {
  CreateQuotationStepsEnum,
  STATIC_GROUP_CHILDREN,
  getChildrenForCategory,
} from "../Quotations/quotationTypes";
import EstimationFloorDetails from "../Estimations/steps/FloorDetails";
import { StorageGroup } from "../Quotations/CreateQuotations";
import {
  CategoriesSlugWithSummaries,
  CategorySlugs,
} from "../Quotations/Components/Products/SummaryHelper";
import {
  DefaultNoImageFound,
  getFullAwsUrl,
  INVOICE_WARNING_VISIBLE_ROLES,
  isInvoiceFeatureEnabled,
  ROLE,
} from "../../../helpers/utils";
import AccountsApprovalModal from "./Components/Modals/AccountsApprovalModal";
import DeliveryDetails from "../Quotations/QuotationDetails/DeliveryDetails";
import { countAnsweredQuestions } from "../Quotations/QuotationDetails/QuotationDetails";
import BOMDetails from "../Quotations/Components/BOMDetails";
import LoadNoticeDetails from "../Quotations/QuotationDetails/LoadNoticeDetails";
import QualityChecklistData from "./QualityChecklistData";
import ProductionJobs from "./ProductionJobs";
import Order2BSItemsDetails from "./Components/Order2BSItemsDetails";
import EcommerceProduct from "./Components/EcommerceProduct";

const { useBreakpoint } = Grid;

const OrderDetails = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    backPath = "",
    backTabPath = "",
    isFromMachine = false,
  } = location.state || {};
  const { id } = useParams<{ id: string }>();
  const [searchParams, setSearchParams] = useSearchParams();

  const screens = useBreakpoint();
  const position = screens.lg ? "left" : "top";

  const USER_PERMISSIONS = usePermissionsChecker(
    PagePermissionNameData?.ORDERS,
  );
  const userData = getDecryptedUserData();
  const inOrderPermissions = manageOrderTypePermission(userData?.role?.key);

  // State

  const { orderDetails, productionPlanData } = useAppSelector(
    (state: RootState) => state.orders,
  );
  console.log(orderDetails, "orderDetailsorderDetails");
  const { getOrderDetailsLoading, authLoading } = useAppSelector(
    (state: RootState) => state.loading,
  );

  const showDesignsTab = !!orderDetails?.is_design;

  const isProductionPlanningTab =
    searchParams.get("tab") === OrderStepsEnum.PRODUCTION_PLANNING;

  const activeStep =
    (searchParams.get("tab") as string) || OrderStepsEnum.CUSTOMER_DETAILS;

  const [isChangeStatus, setIsChangeStatus] = useState(null);

  const [isChangeOrderNumber, setIsChangeOrderNumber] = useState(false);

  const [isSendMail, setIsSendMail] = useState(false);

  const [isDispatchStatus, setIsDispatchStatus] = useState(false);

  const { setExpendProductListTable, expendProductListTable } =
    useOutletContext<any>();
  const [isStatusUpdateError, setIsStatusUpdateError] = useState(null);
  const [statusErrorData, setStatusErrorData] = useState<any>(null);
  const [
    isInstallationInstructionEmailSend,
    setIsInstallationInstructionEmailSend,
  ] = useState(false);

  // dispatch planing states
  const [isModifyDispatchPlaning, setIsModifyDispatchPlaning] = useState(false);

  const [expandedGroups, setExpandedGroups] = useState<string[]>([]);
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [isDropTbcWarningModalVisible, setIsDropTbcWarningModalVisible] =
    useState(false);
  const [hasShownTbcWarning, setHasShownTbcWarning] = useState(false);
  const [isChecklistEditing, setIsChecklistEditing] = useState<boolean>(false);
  const [showUnsavedModal, setShowUnsavedModal] = useState<boolean>(false);
  const [pendingTabKey, setPendingTabKey] = useState<string | null>(null);
  const [checklistResetKey, setChecklistResetKey] = useState<number>(0);
  const [isAccountsApprovalModalVisible, setIsAccountsApprovalModalVisible] =
    useState<boolean>(false);

  useEffect(() => {
    if (
      activeStep !== OrderStepsEnum.INSTALLATION_CHECKLIST ||
      !isChecklistEditing
    )
      return;

    const handlePopState = (e: PopStateEvent) => {
      window.history.pushState(null, "", window.location.href);
      setShowUnsavedModal(true);
    };

    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [activeStep, isChecklistEditing]);

  const [isVariableWarningModalVisible, setIsVariableWarningModalVisible] =
    useState(false);
  const [hasShownVariableWarning, setHasShownVariableWarning] = useState(false);
  const [isConfirmingVariable, setIsConfirmingVariable] = useState(false);
  const [possibleBomDimensions, setPossibleBomDimensions] = useState<any>(null);
  const [isLoadingPossibleDimensions, setIsLoadingPossibleDimensions] =
    useState(false);

  const handleConfirmVariableWarnings = (localWarnings?: any) => {
    if (!id) return;
    setIsConfirmingVariable(true);

    const resolvedItems: any[] = [];
    if (localWarnings) {
      const allItems = [
        ...(localWarnings.parts || []).map((p: any) => ({
          ...p,
          type: "part",
        })),
        ...(localWarnings.components || []).map((c: any) => ({
          ...c,
          type: "component",
        })),
      ];

      for (const item of allItems) {
        resolvedItems.push({
          type: item.type,
          bom_variant_id: item.bom_variant_id,
          part_id: item.part_id,
          component_id: item.component_id,
          original_qty: item.original_qty,
          replacements: (item.replacements || []).map((rep: any) => {
            const variablesObj: Record<string, any> = {};
            if (Array.isArray(rep.variables)) {
              for (const v of rep.variables) {
                let rawValue = v.currentValue;
                if (
                  v.unit &&
                  typeof rawValue === "string" &&
                  rawValue.endsWith(v.unit)
                ) {
                  rawValue = rawValue.slice(0, -v.unit.length);
                }
                const parsed = Number(rawValue);
                variablesObj[v.key] = isNaN(parsed) ? rawValue : parsed;
              }
            }
            return {
              qty: rep.qty,
              variables: variablesObj,
            };
          }),
        });
      }
    }

    dispatch(
      confirmVariableWarningsAPI(
        id,
        resolvedItems,
        () => {
          setIsConfirmingVariable(false);
          setIsVariableWarningModalVisible(false);
          setIsStatusUpdateError(null);
          dispatch(GetOrdersDetailsAPI({ order_id: id }));
          if (orderDetails?.is_2bs_order) {
            dispatch(Get2BSOrderBomAPI({ order_id: id }));
          } else {
            dispatch(GetOrderBomAndWarningsAPI({ order_id: id }));
          }
        },
        () => {
          setIsConfirmingVariable(false);
        },
      ),
    );
  };

  useEffect(() => {
    if (
      orderDetails?.drop_tbc_warnings?.redirect_section_id &&
      !hasShownTbcWarning
    ) {
      setIsDropTbcWarningModalVisible(true);
      setHasShownTbcWarning(true);
    }
  }, [orderDetails?.drop_tbc_warnings, hasShownTbcWarning]);

  const bomVariableWarnings = useMemo(() => {
    if (!orderDetails?.bom_details) return { parts: [], components: [] };

    const partsWarnings: any[] = [];
    const componentsWarnings: any[] = [];

    // Collect options per part_id / component_id across all BOM variants
    const partVarOptions: Record<string, Record<string, Set<string>>> = {};
    const compVarOptions: Record<string, Record<string, Set<string>>> = {};

    orderDetails.bom_details.forEach((bom: any) => {
      (bom?.bom_part_clone_obj || []).forEach((part: any) => {
        const partId = String(part.part_id);
        if (!partVarOptions[partId]) partVarOptions[partId] = {};

        const flatVars = part.variables_flat || {};
        const rawVars = Array.isArray(part.part_variables)
          ? part.part_variables
          : [];
        for (const v of rawVars) {
          if (!v?.key) continue;
          const value =
            flatVars[v.key] ?? flatVars[v.key?.toLowerCase()] ?? v.value;
          if (value !== null && value !== undefined) {
            if (!partVarOptions[partId][v.key])
              partVarOptions[partId][v.key] = new Set();
            partVarOptions[partId][v.key].add(`${value}${v.unit || ""}`);
          }
        }

        (part?.components || []).forEach((comp: any) => {
          const compId = String(comp.component_id);
          if (!compVarOptions[compId]) compVarOptions[compId] = {};
          const compFlat = comp.variables_flat || {};
          const compRawVars = Array.isArray(comp.variables)
            ? comp.variables
            : [];
          for (const v of compRawVars) {
            if (!v?.key) continue;
            const value =
              compFlat[v.key] ?? compFlat[v.key?.toLowerCase()] ?? v.value;
            if (value !== null && value !== undefined) {
              if (!compVarOptions[compId][v.key])
                compVarOptions[compId][v.key] = new Set();
              compVarOptions[compId][v.key].add(`${value}${v.unit || ""}`);
            }
          }
        });
      });
    });

    // Aggregate parts and components by ID + exact dimensional values combination to match production planning aggregation.
    // If ID is same and dimensions match, we merge them and list all variant names.
    const partsMap: Record<string, any> = {};
    const compsMap: Record<string, any> = {};

    orderDetails.bom_details.forEach((bom: any) => {
      const variantName = bom?.bom_variant_clone_obj?.variant_name || "Variant";
      const bomVariantId = String(
        bom?.bom_variant_clone_obj?.variant_id ||
          bom?.bom_variant_id ||
          bom?.variant_id ||
          "",
      );

      const partsNeedingConf = (bom?.bom_part_clone_obj || []).filter(
        (part: any) => part?.variable_confirmation_required,
      );

      // If only 1 part per product needs variable confirmation, skip as it is not necessary
      if (partsNeedingConf.length > 1) {
        const variantDims: Record<string, number> = {};
        const variantObj = bom?.bom_variant_clone_obj;
        if (variantObj) {
          [
            "height",
            "width",
            "depth",
            "length",
            "thickness",
            "reinforced_height",
            "gauge",
            "drop",
            "first_beam_level",
            "first_shelf_level",
          ].forEach((key) => {
            if (variantObj[key] !== undefined && variantObj[key] !== null) {
              const num = Number(
                String(variantObj[key]).replace(/[^\d.-]/g, ""),
              );
              if (!isNaN(num) && num > 0) variantDims[key] = num;
            }
          });

          const vk = variantObj.variables_keys || variantObj.with_key_value;
          if (vk) {
            const strVal =
              typeof vk === "string" ? vk : vk.with_key_value || "";
            if (strVal) {
              const pairs = String(strVal).split(/[,_]/);
              for (const pair of pairs) {
                const [k, v] = pair.split(":");
                if (k && v) {
                  const cleanK = k.trim().toLowerCase();
                  const num = Number(String(v).replace(/[^\d.-]/g, ""));
                  if (!isNaN(num) && num > 0) {
                    variantDims[cleanK] = num;
                  }
                }
              }
            }
            if (typeof vk === "object" && vk.only_keys && vk.only_values) {
              const keys = String(vk.only_keys).split(",");
              const vals = String(vk.only_values).split(",");
              keys.forEach((k, idx) => {
                const cleanK = k.trim().toLowerCase();
                if (vals[idx]) {
                  const num = Number(String(vals[idx]).replace(/[^\d.-]/g, ""));
                  if (!isNaN(num) && num > 0) {
                    variantDims[cleanK] = num;
                  }
                }
              });
            }
          }
        }

        partsNeedingConf.forEach((part: any) => {
          const name = part.part_name || part.part_clone?.name;
          const partId = String(part.part_id);
          const flatVars = part.variables_flat || {};
          const rawVars = Array.isArray(part.part_variables)
            ? part.part_variables
            : [];

          let relation =
            part.variable_relation ||
            part.part_clone?.variable_relation ||
            null;
          if (typeof relation === "string" && relation.includes(":")) {
            const [part_variable, product_variable] = relation.split(":");
            relation = { part_variable, product_variable };
          }

          const formattedVars = rawVars
            .filter((v: any) => {
              if (!v?.key) return false;
              const val =
                v.value ?? flatVars[v.key] ?? flatVars[v.key?.toLowerCase()];
              return val !== null && val !== undefined;
            })
            .map((v: any) => {
              const resolvedVal =
                v.value ?? flatVars[v.key] ?? flatVars[v.key?.toLowerCase()];

              const currentVal = `${resolvedVal}${v.unit || ""}`;
              const backendOpts =
                part.variable_options?.[v.key] ||
                part.variable_options?.[v.key?.toLowerCase()];
              const optionSet =
                backendOpts && backendOpts.length > 0
                  ? new Set(
                      backendOpts.map((val: any) => `${val}${v.unit || ""}`),
                    )
                  : partVarOptions[partId]?.[v.key] || new Set([currentVal]);
              return {
                key: v.key,
                currentValue: currentVal,
                options: Array.from(optionSet).sort(
                  (a: any, b: any) => parseFloat(a) - parseFloat(b),
                ),
                unit: v.unit || "",
              };
            });

          // Create a unique key using partId + formattedVars values
          const dimensionKeyStr = formattedVars
            .map((v: any) => `${v.key}:${v.currentValue}`)
            .sort()
            .join("|");
          const aggregationKey = `${bomVariantId}_${partId}_${dimensionKeyStr}`;

          const bomQty = Number(bom?.quantity || bom?.qty || 1);
          const partQty = Number(
            part.total_qty || (part.qty ? part.qty * bomQty : 0),
          );

          if (!partsMap[aggregationKey]) {
            partsMap[aggregationKey] = {
              type: "part",
              bom_variant_id: bomVariantId,
              part_id: partId,
              variantName,
              variantNames: [variantName],
              itemName: name,
              variables: formattedVars,
              qty: partQty,
              variable_combinations: part.variable_combinations || [],
              variable_relation: relation,
              variant_dimensions: variantDims,
            };
          } else {
            partsMap[aggregationKey].qty += partQty;
            if (!partsMap[aggregationKey].variantNames.includes(variantName)) {
              partsMap[aggregationKey].variantNames.push(variantName);
            }
            // Format variantNames list with sequence prefixes e.g. "1. Variant A, 2. Variant B"
            partsMap[aggregationKey].variantName = partsMap[
              aggregationKey
            ].variantNames
              .map((name: string, index: number) => `${index + 1}. ${name}`)
              .join(", ");
          }
        });
      }

      (bom?.bom_part_clone_obj || []).forEach((part: any) => {
        const compsNeedingConf = (part?.components || []).filter(
          (comp: any) => comp?.variable_confirmation_required,
        );

        // If only 1 component per part needs variable confirmation, skip as it is not necessary
        if (compsNeedingConf.length > 1) {
          compsNeedingConf.forEach((comp: any) => {
            const name = comp.component_name || comp.component_clone?.name;
            const compId = String(comp.component_id);
            const partId = String(part.part_id);
            const compFlat = comp.variables_flat || {};
            const compRawVars = Array.isArray(comp.variables)
              ? comp.variables
              : [];

            const formattedVars = compRawVars
              .filter((v: any) => {
                if (!v?.key) return false;
                const val =
                  compFlat[v.key] ?? compFlat[v.key?.toLowerCase()] ?? v.value;
                return val !== null && val !== undefined;
              })
              .map((v: any) => {
                const resolvedVal =
                  compFlat[v.key] ?? compFlat[v.key?.toLowerCase()] ?? v.value;
                const currentVal = `${resolvedVal}${v.unit || ""}`;
                const backendOpts =
                  comp.variable_options?.[v.key] ||
                  comp.variable_options?.[v.key?.toLowerCase()];
                const optionSet =
                  backendOpts && backendOpts.length > 0
                    ? new Set(
                        backendOpts.map((val: any) => `${val}${v.unit || ""}`),
                      )
                    : compVarOptions[compId]?.[v.key] || new Set([currentVal]);
                return {
                  key: v.key,
                  currentValue: currentVal,
                  options: Array.from(optionSet).sort(
                    (a: any, b: any) => parseFloat(a) - parseFloat(b),
                  ),
                  unit: v.unit || "",
                };
              });

            // Create a unique key using componentId + formattedVars values
            const dimensionKeyStr = formattedVars
              .map((v: any) => `${v.key}:${v.currentValue}`)
              .sort()
              .join("|");
            const aggregationKey = `${bomVariantId}_${compId}_${dimensionKeyStr}`;

            const bomQty = Number(bom?.quantity || bom?.qty || 1);
            const compQty = Number(
              comp.qty ? comp.qty * bomQty : comp.total_qty || 0,
            );
            const partName = part.part_name || part.part_clone?.name || "";

            if (!compsMap[aggregationKey]) {
              compsMap[aggregationKey] = {
                type: "component",
                bom_id: String(bom?.bom_variant_id || bom?._id || ""),
                bom_variant_id: bomVariantId,
                part_id: partId,
                component_id: compId,
                variantName,
                variantNames: [variantName],
                parentPartName: partName,
                parentPartNames: partName ? [partName] : [],
                itemName: name,
                variables: formattedVars,
                qty: compQty,
                variable_combinations: comp.variable_combinations || [],
              };
            } else {
              compsMap[aggregationKey].qty += compQty;
              if (
                !compsMap[aggregationKey].variantNames.includes(variantName)
              ) {
                compsMap[aggregationKey].variantNames.push(variantName);
              }
              if (
                partName &&
                !compsMap[aggregationKey].parentPartNames.includes(partName)
              ) {
                compsMap[aggregationKey].parentPartNames.push(partName);
              }
              compsMap[aggregationKey].variantName = compsMap[
                aggregationKey
              ].variantNames
                .map((n: string, index: number) => `${index + 1}. ${n}`)
                .join(", ");
              compsMap[aggregationKey].parentPartName = compsMap[
                aggregationKey
              ].parentPartNames
                .map((n: string, index: number) => `${index + 1}. ${n}`)
                .join(", ");
            }
          });
        }
      });
    });

    return {
      parts: Object.values(partsMap),
      components: Object.values(compsMap),
    };
  }, [orderDetails]);

  useEffect(() => {
    if (isStatusUpdateError === "VARIABLE_CONFIRMATION_REQUIRED") {
      if (
        bomVariableWarnings.parts.length === 0 &&
        bomVariableWarnings.components.length === 0
      ) {
        handleConfirmVariableWarnings();
        setIsStatusUpdateError(null);
      }
    }
  }, [isStatusUpdateError, bomVariableWarnings]);

  useEffect(() => {
    if (
      !orderDetails?.is_2bs_order &&
      !orderDetails?.drop_tbc_warnings?.redirect_section_id &&
      !orderDetails?.is_variable_confirmation_completed &&
      bomVariableWarnings.parts.length + bomVariableWarnings.components.length >
        0 &&
      !hasShownVariableWarning
    ) {
      setIsVariableWarningModalVisible(true);
      setHasShownVariableWarning(true);
    }
  }, [
    orderDetails?.is_2bs_order,
    bomVariableWarnings,
    hasShownVariableWarning,
    orderDetails?.is_variable_confirmation_completed,
    orderDetails?.drop_tbc_warnings?.redirect_section_id,
  ]);

  // dispatch planing state finish

  useEffect(() => {
    if (!id) return;
    dispatch(GetOrdersDetailsAPI({ order_id: id }));
  }, [id, dispatch]);

  useEffect(() => {
    if (!id || !orderDetails?._id || orderDetails._id !== id) return;
    if (orderDetails.is_2bs_order) {
      dispatch(Get2BSOrderBomAPI({ order_id: id }));
    } else {
      dispatch(GetOrderBomAndWarningsAPI({ order_id: id }));
    }
  }, [id, orderDetails?._id, orderDetails?.is_2bs_order, dispatch]);

  const STATIC_STORAGE_GROUPS = useMemo((): StorageGroup[] => {
    const categories = orderDetails?.categories_snapshot;
    return (Array.isArray(categories) ? categories : []).map((item: any) => ({
      ...item,
      label: item.name,
      key: item._id,
      slug: item.slug,
      category_id: item.category_id,
      item_id: item._id, // the snapshot _id
      product_type_name: item.product_type_name,
    }));
  }, [orderDetails]);

  useEffect(() => {
    if (STATIC_STORAGE_GROUPS.length > 0) {
      setExpandedGroups(STATIC_STORAGE_GROUPS.map((group) => group.key));
    }
  }, [STATIC_STORAGE_GROUPS]);

  const toggleGroup = (key: string) => {
    setExpandedGroups((prev) =>
      prev.includes(key) ? prev.filter((g) => g !== key) : [...prev, key],
    );
  };

  const checklistCount = useMemo(() => {
    return countAnsweredQuestions(orderDetails?.checklist_answers);
  }, [orderDetails]);

  const totalQuestions = orderDetails?.checklist_answers?.length || 0;

  const getStaticNestedStepKey = (groupKey: string, childKey: string) =>
    `${groupKey}__${childKey}`;

  const hasMezzanineFloor = useMemo(() => {
    if (orderDetails?.mezzanine_floor) return true;
    const categories = orderDetails?.categories_snapshot || [];
    return categories.some(
      (item: any) =>
        item?.slug === "mezzanine-floors-category" ||
        item?.category_id?.slug === "mezzanine-floors-category" ||
        item?.product_type_name?.toLowerCase()?.includes("mezzanine") ||
        item?.name?.toLowerCase()?.includes("mezzanine"),
    );
  }, [orderDetails]);

  const isOnlyMezzanineFloor = useMemo(() => {
    if (!hasMezzanineFloor) return false;
    const categories = orderDetails?.categories_snapshot || [];
    const nonMezzanineCategories = categories.filter((item: any) => {
      const isMezz =
        item?.slug === "mezzanine-floors-category" ||
        item?.category_id?.slug === "mezzanine-floors-category" ||
        item?.product_type_name?.toLowerCase()?.includes("mezzanine") ||
        item?.name?.toLowerCase()?.includes("mezzanine");
      return !isMezz;
    });
    return nonMezzanineCategories.length === 0;
  }, [orderDetails, hasMezzanineFloor]);

  const is2BSOrder = Boolean(orderDetails?.is_2bs_order);
  const isEccomerceOrder = Boolean(orderDetails?.is_eccomerce_order);

  const order2BSItems = useMemo(() => {
    return Array.isArray(orderDetails?.order_2bs_items)
      ? orderDetails.order_2bs_items
      : [];
  }, [orderDetails?.order_2bs_items]);

  const twoBSProducts = useMemo(() => {
    return order2BSItems.filter(
      (it: any) =>
        it?.item_type === "product" || it?.item_type === "lean_product",
    );
  }, [order2BSItems]);

  const twoBSParts = useMemo(() => {
    return order2BSItems.filter(
      (it: any) => it?.item_type === "part" || it?.part_id,
    );
  }, [order2BSItems]);

  const twoBSComponents = useMemo(() => {
    return order2BSItems.filter(
      (it: any) => it?.item_type === "component" || it?.component_id,
    );
  }, [order2BSItems]);

  const orderEcommerceItems = useMemo(() => {
    return Array.isArray(orderDetails?.order_eccomerce_items)
      ? orderDetails.order_eccomerce_items
      : [];
  }, [orderDetails?.order_eccomerce_items]);

  const ecommerceProducts = useMemo(() => {
    return orderEcommerceItems.filter(
      (it: any) =>
        !it?.item_type ||
        it?.item_type === "product" ||
        it?.item_type === "lean_product",
    );
  }, [orderEcommerceItems]);

  const ecommerceParts = useMemo(() => {
    return orderEcommerceItems.filter(
      (it: any) => it?.item_type === "part" || Boolean(it?.part_id),
    );
  }, [orderEcommerceItems]);

  const ecommerceComponents = useMemo(() => {
    return orderEcommerceItems.filter(
      (it: any) => it?.item_type === "component" || Boolean(it?.component_id),
    );
  }, [orderEcommerceItems]);

  const items = useMemo(() => {
    if (is2BSOrder) {
      const tabs: any[] = [
        {
          label: `Customer Details`,
          key: OrderStepsEnum.CUSTOMER_DETAILS,
          component: (
            <CustomerDetails
              data={orderDetails}
              setData={() => {}}
              isOrderView={true}
            />
          ),
        },
        {
          label: `Products (${twoBSProducts.length})`,
          key: "2bs-products",
          component: (
            <Order2BSItemsDetails
              type="products"
              items={twoBSProducts}
              currency={orderDetails?.currency}
              conversionRate={orderDetails?.conversion_rate}
            />
          ),
        },
        {
          label: `Parts (${twoBSParts.length})`,
          key: "2bs-parts",
          component: (
            <Order2BSItemsDetails
              type="parts"
              items={twoBSParts}
              currency={orderDetails?.currency}
              conversionRate={orderDetails?.conversion_rate}
            />
          ),
        },
        {
          label: `Components (${twoBSComponents.length})`,
          key: "2bs-components",
          component: (
            <Order2BSItemsDetails
              type="components"
              items={twoBSComponents}
              currency={orderDetails?.currency}
              conversionRate={orderDetails?.conversion_rate}
            />
          ),
        },
        {
          label: `BOM Details`,
          key: OrderStepsEnum.BOM_DETAILS,
          component: (
            <BOMDetails
              data={orderDetails}
              isOrder={true}
              orderId={orderDetails?._id || id}
            />
          ),
        },
      ];

      if (orderDetails?.planning_details) {
        tabs.push({
          label: `Production Planning`,
          key: OrderStepsEnum.PRODUCTION_PLANNING,
          component: (
            <ImproveProductionPlaning
              planning_details={orderDetails?.planning_details}
            />
          ),
        });
        tabs.push({
          label: `Quality Checklist`,
          key: OrderStepsEnum.QUALITY_CHECKLIST,
          component: <QualityChecklistData />,
        });
        tabs.push({
          label: `Dispatch Planning`,
          key: OrderStepsEnum.DISPATCH_PLANNING,
          component: (
            <DispatchPlanning
              isModifyDispatchPlaning={isModifyDispatchPlaning}
              setIsModifyDispatchPlaning={setIsModifyDispatchPlaning}
            />
          ),
        });
        tabs.push({
          label: `Print Labels`,
          key: OrderStepsEnum.STICKER_JOBS,
          component: <Jobs />,
        });
        tabs.push({
          label: `Jobs`,
          key: OrderStepsEnum.JOBS,
          component: <ProductionJobs />,
        });
      }

      tabs.push({
        label: `Notes`,
        key: OrderStepsEnum.NOTES,
        component: (
          <NotesDetails
            data={orderDetails}
            quoteId={orderDetails?.obj_quote_id}
          />
        ),
      });

      return tabs;
    }

    if (isEccomerceOrder) {
      const tabs: any[] = [
        {
          label: `Customer Details`,
          key: OrderStepsEnum.CUSTOMER_DETAILS,
          component: (
            <CustomerDetails
              data={orderDetails}
              setData={() => {}}
              isOrderView={true}
            />
          ),
        },
        {
          label: `Products (${ecommerceProducts.length})`,
          key: "ecommerce-products",
          component: (
            <EcommerceProduct
              type="products"
              items={ecommerceProducts}
              currency={orderDetails?.currency}
              conversionRate={orderDetails?.conversion_rate}
            />
          ),
        },
        {
          label: `Parts (${ecommerceParts.length})`,
          key: "ecommerce-parts",
          component: (
            <EcommerceProduct
              type="parts"
              items={ecommerceParts}
              currency={orderDetails?.currency}
              conversionRate={orderDetails?.conversion_rate}
            />
          ),
        },
        {
          label: `Components (${ecommerceComponents.length})`,
          key: "ecommerce-components",
          component: (
            <EcommerceProduct
              type="components"
              items={ecommerceComponents}
              currency={orderDetails?.currency}
              conversionRate={orderDetails?.conversion_rate}
            />
          ),
        },
      ];

      tabs.push({
        label: `Notes`,
        key: OrderStepsEnum.NOTES,
        component: (
          <NotesDetails
            data={orderDetails}
            quoteId={orderDetails?.obj_quote_id}
          />
        ),
      });

      return tabs;
    }
    const tabs = [
      {
        label: `Customer Details`,
        key: OrderStepsEnum.CUSTOMER_DETAILS,
        component: (
          <CustomerDetails
            data={orderDetails}
            setData={() => {}}
            isOrderView={true}
            // paymentPermission={inOrderPermissions?.milestone}
          />
        ),
      },
      {
        label: `Bespoke / Bought-In Items`,
        key: OrderStepsEnum.BESPOKE_ITEMS,
        component: <BespokeItemsDetails data={orderDetails} />,
      },
      {
        label: `Services`,
        key: OrderStepsEnum.SERVICES,
        component: <ServiceDetails data={orderDetails} />,
      },
      {
        label: `BOM Details`,
        key: OrderStepsEnum.BOM_DETAILS,
        component: (
          <BOMDetails
            data={orderDetails}
            isOrder={true}
            orderId={orderDetails?._id || id}
          />
        ),
      },
      // ...(
      //   (orderDetails?.categories_snapshot || []).some((item: any) => item?.slug === "adjustable-pallet-racking-apr")
      //     ? [
      {
        label: `Load Notices and Signs`,
        key: OrderStepsEnum.LOAD_NOTICES,
        component: (
          <LoadNoticeDetails
            data={orderDetails}
            quoteId={orderDetails?.obj_quote_id}
          />
        ),
      },
      //       ]
      //     : []
      // ),
      ...(orderDetails?.installation_mark_up_required
        ? [
            {
              label: (
                <span>
                  Installation Checklist
                  {totalQuestions > 0 && (
                    <span className="ms-2">
                      ({checklistCount} / {totalQuestions})
                    </span>
                  )}
                </span>
              ),
              key: OrderStepsEnum.INSTALLATION_CHECKLIST,
              component: (
                <OrderInstallationChecklist
                  key={checklistResetKey}
                  data={orderDetails}
                  setIsEditing={setIsChecklistEditing}
                  onUpdateOrderDetails={(updatedData) =>
                    dispatch({
                      type: "GET_ORDERS_DETAILS",
                      payload: updatedData,
                    })
                  }
                />
              ),
            },
          ]
        : []),
      {
        label: `Delivery`,
        key: OrderStepsEnum.COLLECTION_DELIVERY,
        component: <DeliveryDetails data={orderDetails} />,
      },
      {
        label: `Notes`,
        key: OrderStepsEnum.NOTES,
        component: (
          <NotesDetails
            data={orderDetails}
            quoteId={orderDetails?.obj_quote_id}
          />
        ),
      },
      {
        label: `Designs`,
        key: OrderStepsEnum.DESIGNS,
        component: <DesignsDetails data={orderDetails} />,
      },
    ];
    // if (showDesignsTab) {
    //   tabs.push({
    //     label: `Designs`,
    //     key: OrderStepsEnum.DESIGNS,
    //     component: <DesignsDetails data={orderDetails} />,
    //   });
    // }
    if (orderDetails?.planning_details && !isOnlyMezzanineFloor) {
      tabs.push({
        label: `Production Planning`,
        key: OrderStepsEnum.PRODUCTION_PLANNING,
        component: (
          <ImproveProductionPlaning
            planning_details={orderDetails?.planning_details}
          />
        ),
      });
    }
    // if (orderDetails?.planning_details && !isOnlyMezzanineFloor) {
    //   tabs.push({
    //     label: `Quality Checklist`,
    //     key: OrderStepsEnum.QUALITY_CHECKLIST,
    //     component: <QualityChecklistData />,
    //   });
    // }
    if (orderDetails?.planning_details) {
      tabs.push({
        label: `Dispatch Planning`,
        key: OrderStepsEnum.DISPATCH_PLANNING,
        component: (
          <DispatchPlanning
            isModifyDispatchPlaning={isModifyDispatchPlaning}
            setIsModifyDispatchPlaning={setIsModifyDispatchPlaning}
          />
        ),
      });
    }
    if (orderDetails?.planning_details && hasMezzanineFloor) {
      tabs.push({
        label: `Mezzanine Floor Dispatch Planning`,
        key: OrderStepsEnum.MEZZANINE_DISPATCH_PLANNING,
        component: <MezzanineDispatchPlanning />,
      });
    }
    if (orderDetails?.planning_details) {
      tabs.push({
        label: `Print Labels`,
        key: OrderStepsEnum.STICKER_JOBS,
        component: <Jobs />,
      });
    }
    // if (orderDetails?.planning_details) {
    //   tabs.push({
    //     label: `Jobs`,
    //     key: OrderStepsEnum.JOBS,
    //     component: <ProductionJobs />,
    //   });
    // }
    return tabs;
  }, [
    orderDetails,
    is2BSOrder,
    twoBSProducts,
    twoBSParts,
    twoBSComponents,
    id,
    showDesignsTab,
    isModifyDispatchPlaning,
    hasMezzanineFloor,
    isOnlyMezzanineFloor,
  ]);

  const activeComponent = useMemo(() => {
    // 1. Check if it's a dynamic step (e.g. [categoryId]__products)
    if (activeStep.includes("__")) {
      const [categoryId, subStep] = activeStep.split("__");
      const groupData = STATIC_STORAGE_GROUPS.find((g) => g.key === categoryId);

      if (groupData) {
        if (
          subStep === CreateQuotationStepsEnum.SUMMARY ||
          subStep === CreateQuotationStepsEnum.PRODUCTS ||
          subStep === CreateQuotationStepsEnum.ACCESSORIES
        ) {
          return (
            <ProductDetails
              data={orderDetails}
              activeTab={subStep}
              categoryData={groupData}
              quoteId={orderDetails?.obj_quote_id}
              isOrderView={true}
            />
          );
        } else if (
          subStep === CreateQuotationStepsEnum.FLOOR_DETAILS ||
          subStep === "floor-details"
        ) {
          return (
            <div className="d-flex flex-column gap-4 animate-fade-in">
              <EstimationFloorDetails readOnly={true} data={orderDetails} />
            </div>
          );
        }
      }
    }

    // 2. Check if it's a static item
    const staticItem = items.find((i) => {
      if (i.key === activeStep) return true;
      if (
        activeStep === "products" &&
        (i.key === "2bs-products" || i.key === "ecommerce-products")
      )
        return true;
      if (
        activeStep === "parts" &&
        (i.key === "2bs-parts" || i.key === "ecommerce-parts")
      )
        return true;
      if (
        activeStep === "components" &&
        (i.key === "2bs-components" || i.key === "ecommerce-components")
      )
        return true;
      return false;
    });
    if (staticItem) return staticItem.component;

    // 3. Replace fallback
    return items[0]?.component;
  }, [activeStep, items, STATIC_STORAGE_GROUPS, orderDetails]);

  if (getOrderDetailsLoading && !orderDetails) {
    return (
      <div className="h-100 d-flex justify-content-center align-items-center">
        <Spin size="large" tip="Loading details..." />
      </div>
    );
  }
  // Some older orders have order_id set to the raw MongoDB ObjectId instead of
  // a human-readable display number. Guard against that by falling back to display_quote_id.
  const isObjectId = (val: any) =>
    typeof val === "string" && /^[a-f\d]{24}$/i.test(val);
  const orderIdToDisplay = isObjectId(orderDetails?.order_id)
    ? orderDetails?.display_quote_id || orderDetails?.order_id
    : orderDetails?.order_id;
  const companyName = orderDetails?.customer_snapshot?.company_name || "";
  const status = orderDetails?.order_status || OrderStatusEnum.ORDER_CREATED;
  const statusLabel = OrderStatusLabels[status as OrderStatusEnum] || status;
  const nextStatus = getNextStatus(orderDetails, status);
  const statusFindClass = (status: string) => {
    switch (status) {
      case OrderStatusEnum.ORDER_CREATED:
        return "statusDraft";
      case OrderStatusEnum.PRODUCTION_PLANNING:
        return "statusDesignApproved";
      case OrderStatusEnum.PRODUCTION_STARTED:
        return "statusApproved";
      case OrderStatusEnum.IN_PRODUCTION:
        return "statusApproved";
      case OrderStatusEnum.READY_FOR_DISPATCH:
        return "statusSent";
      case OrderStatusEnum.DISPATCHED:
        return "statusSave";
      case OrderStatusEnum.DELIVERED:
        return "statusDelivered";
      case OrderStatusEnum.UNDER_INSTALLATION:
        return "statusUnderInstallation";
      case OrderStatusEnum.INSTALLED:
        return "statusDesignPending";
      case OrderStatusEnum.CLOSED:
        return "statusClosed";
      default:
        return "statusDraft"; // Fallback
    }
  };

  const handleChangeStatus = () => {
    if (status) {
      // const payload = {
      //   order_status: ORDER_NAXT_STATUS_FLOW[status]?.status,
      // };
      if (nextStatus?.key == "Delivered" && !orderDetails?.planning_details) {
        setIsChangeStatus({
          ...nextStatus,
          title: "Ready For Installation, Are You Sure?",
          description:
            "This action will update the order status and notify the assigned team. Please confirm before proceeding, as this action cannot be undone.",
        });
      } else {
        setIsChangeStatus(nextStatus);
      }
    }
  };

  const showProductionStatus = () => {
    if (orderDetails) {
      return nextStatus?.key == "Delivered" && !orderDetails?.planning_details
        ? "Ready For Installation"
        : nextStatus?.key;
    } else {
      return "-";
    }
  };

  const ActionMenu = () => {
    const statusData = status ? showProductionStatus() : <BtnLoader />;

    return (
      <Menu>
        {statusData == "Closed" &&
        orderDetails?.installation_planning &&
        !orderDetails?.installation_confirmation_details ? (
          <Tooltip title="Installation Confirmation Required From Client Side">
            <Menu.Item
              key="notify_cleint"
              onClick={handleChangeStatus}
              disabled
            >
              {statusData}
            </Menu.Item>
          </Tooltip>
        ) : (
          <Menu.Item key="notify_cleint" onClick={handleChangeStatus}>
            {statusData}
          </Menu.Item>
        )}
        <Menu.Item
          key="2"
          onClick={() => {
            navigate(`/orders/${orderDetails?._id}/audit-log`, {
              state: {
                backPath: `/orders/${orderDetails?._id}`,
                backTabPath: searchParams.get("tab") || activeStep,
              },
            });
          }}
        >
          <div className="text-black d-flex align-items-center gap-2 svg-20">
            Audit Log
          </div>
        </Menu.Item>
      </Menu>
    );
  };

  const handleTabChange = (key: string) => {
    if (
      activeStep === OrderStepsEnum.INSTALLATION_CHECKLIST &&
      isChecklistEditing &&
      key !== OrderStepsEnum.INSTALLATION_CHECKLIST
    ) {
      setPendingTabKey(key);
      setShowUnsavedModal(true);
      return;
    }
    setSearchParams({ tab: key });
    setIsMobileNavOpen(false);
  };

  const ORDER_STATUS_FLOW = [
    OrderStatusEnum.ORDER_CREATED,
    // OrderStatusEnum.PRODUCTION_PLANNING,
    // OrderStatusEnum.PRODUCTION_STARTED,
    OrderStatusEnum.IN_PRODUCTION,
    OrderStatusEnum.READY_FOR_DISPATCH,
    OrderStatusEnum.DISPATCHED,
    OrderStatusEnum.DELIVERED,
    OrderStatusEnum.UNDER_INSTALLATION,
    OrderStatusEnum.INSTALLED,
  ];
  const currentStatusIndex = orderDetails
    ? filteredStatusFlow(orderDetails)?.findIndex((step: any) => {
        if (
          status === OrderStatusEnum.PRODUCTION_PLANNING ||
          status === OrderStatusEnum.PRODUCTION_STARTED
        ) {
          return step.status === OrderStatusEnum.IN_PRODUCTION;
        }
        return step.status == (status || OrderStatusEnum.ORDER_CREATED);
      })
    : 1;

  const isFinalInvoicePending = !!orderDetails?.enable_to_create_final_invoice;

  return getOrderDetailsLoading ? (
    <FullScreenLoader />
  ) : USER_PERMISSIONS?.READ ? (
    <div
      className={
        expendProductListTable ? "p-2" : "page-content h-100 px-40 py-40"
      }
    >
      {expendProductListTable || isModifyDispatchPlaning ? (
        ""
      ) : (
        <>
          <div
            className={`d-flex flex-column gap-md-2 gap-0 ${
              isInvoiceFeatureEnabled &&
              INVOICE_WARNING_VISIBLE_ROLES.includes(userData?.role?.key) &&
              orderDetails?.invoice_warnings &&
              orderDetails?.invoice_warnings.length > 0
                ? `mb-2`
                : `mb-3`
            }`}
          >
            <div className="d-flex flex-md-nowrap flex-wrap gap-md-3 gap-2 justify-content-between align-items-sm-center align-items-start">
              <div className="d-flex align-items-sm-center align-items-start gap-md-3 gap-2 order-md-1 order-1 w-mob-85">
                <span
                  onClick={() => {
                    // navigate(isProductionPlanningTab ? -1 : "/orders");
                    if (isProductionPlanningTab) {
                      if (isFromMachine && backPath) {
                        navigate(backPath || "/orders");
                      } else {
                        setSearchParams({ tab: "customer-details" });
                      }
                      // navigate(-1);
                    } else {
                      if (backPath && backTabPath && backTabPath !== "false") {
                        navigate(`${backPath}`, {
                          state: { tabPath: backTabPath },
                        });
                      } else if (backPath) {
                        navigate(backPath);
                      } else {
                        navigate("/orders");
                      }
                    }
                  }}
                  className="svg-24 cursor-pointer"
                >
                  {svg?.backArrow}
                </span>
                <h2 className="fw-bold page-title mb-0 d-flex flex-wrap align-items-sm-center gap-2">
                  Order Details{" "}
                  {orderIdToDisplay && companyName
                    ? `#${orderIdToDisplay} | ${companyName}`
                    : ""}
                  {is2BSOrder && (
                    <Tag
                      color="blue"
                      className="fs-7 py-0 px-2 fw-semibold m-0"
                      style={{ borderRadius: "4px" }}
                    >
                      2BS Order
                    </Tag>
                  )}
                  {isEccomerceOrder && (
                    <Tag
                      color="orange"
                      className="fs-7 py-0 px-2 fw-semibold m-0"
                      style={{ borderRadius: "4px" }}
                    >
                      Ecommerce Order
                    </Tag>
                  )}
                  {isEccomerceOrder && orderDetails?.order_placed_type && (
                    <Tag
                      color={
                        orderDetails?.order_placed_type === "takeaway"
                          ? "purple"
                          : "cyan"
                      }
                      className="fs-7 py-0 px-2 fw-semibold m-0 text-capitalize"
                      style={{ borderRadius: "4px" }}
                    >
                      {orderDetails?.order_placed_type}
                    </Tag>
                  )}
                  {status == OrderStatusEnum?.ORDER_CREATED &&
                  USER_PERMISSIONS?.MODIFY ? (
                    <Tooltip title="Edit Order Id">
                      <span
                        className="svg-32 cursor-pointer"
                        onClick={() => setIsChangeOrderNumber(true)}
                      >
                        {svg?.tableEditIcon}
                      </span>
                    </Tooltip>
                  ) : (
                    ""
                  )}
                  {isInvoiceFeatureEnabled &&
                    isFinalInvoicePending &&
                    orderDetails?._id && (
                      <span
                        onClick={(e) => {
                          e.stopPropagation();
                          orderDetails?._id &&
                            navigate(
                              `/invoices/create-invoice/${orderDetails?._id}/final`,
                            );
                        }}
                        className="cursor-pointer ms-md-2"
                        style={{
                          color: "red",
                          fontWeight: "normal",
                          fontSize: "14px",
                        }}
                      >
                        Final Invoice Pending -{" "}
                        <span style={{ textDecoration: "underline" }}>
                          Create
                        </span>
                      </span>
                    )}
                </h2>
              </div>
              {!getOrderDetailsLoading ? (
                <div className="ms-md-auto order-md-2 order-3 d-flex flex-wrap gap-md-3 gap-2 orderStatusMob">
                  {OrderStatusEnum.CLOSED != orderDetails?.order_status &&
                  orderDetails?.sent_mails?.installation_instruction ? (
                    <span
                      className={
                        "d-inline-flex align-items-center fw-semibold fs-6 svg-10 quotation-status emailSent"
                      }
                      style={{ whiteSpace: "nowrap" }}
                    >
                      {svg.dotIcon}
                      <span className="ms-1 d-inline-block lh-normal">
                        Instruction Email Sent
                      </span>
                    </span>
                  ) : (
                    ""
                  )}

                  <span
                    className={
                      "d-inline-flex align-items-center fw-semibold fs-6 svg-10 quotation-status " +
                      statusFindClass(status)
                    }
                    style={{ whiteSpace: "nowrap" }}
                  >
                    {svg.dotIcon}
                    <span className="ms-1 d-inline-block lh-normal">
                      {statusLabel == "Delivered" &&
                      !orderDetails?.planning_details
                        ? "Ready For Installation"
                        : statusLabel}
                    </span>
                  </span>

                  {orderDetails?.accounts_approved !== true &&
                      (() => {
                        const canApprove = [
                          ROLE.ADMIN,
                          ROLE.SUB_ADMIN,
                          ROLE.ACCOUNTS,
                          ROLE.CREDIT_CONTROLLER
                        ].includes(userData?.role?.key);
                        return (
                          <span
                            role={canApprove ? "button" : undefined}
                            tabIndex={canApprove ? 0 : undefined}
                            className={`accountsApprovalBadge needed fs-6 text-nowrap ${!canApprove ? "non-clickable" : ""}`}
                            style={!canApprove ? { cursor: "default", pointerEvents: "none" } : undefined}
                            onClick={
                              canApprove
                                ? () => setIsAccountsApprovalModalVisible(true)
                                : undefined
                            }
                          >
                            {svg.dotIcon}
                            Accounts Approval Needed
                          </span>
                        );
                      })()
                    }
                </div>
              ) : (
                ""
              )}
              {/* Action Menu */}
              {USER_PERMISSIONS?.MODIFY && nextStatus?.key ? (
                <Dropdown
                  overlay={ActionMenu}
                  trigger={["click"]}
                  placement="bottomRight"
                  className="order-md-3 order-2"
                >
                  <span className="svg-46">{svg?.downloadBtn}</span>
                </Dropdown>
              ) : (
                ""
              )}
            </div>
          </div>
          {isInvoiceFeatureEnabled &&
            INVOICE_WARNING_VISIBLE_ROLES.includes(userData?.role?.key) &&
            orderDetails?.invoice_warnings &&
            orderDetails?.invoice_warnings.length > 0 && (
              <Alert
                type="warning"
                showIcon
                className="py-1 px-3 m-0 invoice-warning-alert mb-3"
                style={{ width: "max-content", maxWidth: "100%" }}
                message={
                  <div className="fs-6 fs-6-mob fw-normal">
                    <strong className="invoice-warning-title">
                      Invoice Warning:
                    </strong>
                    <span className="d-none d-md-inline ms-1 invoice-warning-text">
                      - {orderDetails.invoice_warnings.join(", ")}
                    </span>
                    <div className="d-md-none ms-2 invoice-warning-text">
                      {orderDetails.invoice_warnings.map(
                        (w: string, i: number) => (
                          <div key={i}>- {w}</div>
                        ),
                      )}
                    </div>
                  </div>
                }
              />
            )}
        </>
      )}

      {!isProductionPlanningTab && !isModifyDispatchPlaning && (
        <div className="custom-dark-steps-container orderDetails-steps mb-3">
          <Steps
            progressDot
            current={currentStatusIndex}
            direction="horizontal"
            responsive={false}
            items={filteredStatusFlow(orderDetails)?.map((elem: any) => ({
              title: elem?.title,
            }))}
          />
        </div>
      )}
      {status == OrderStatusEnum.READY_FOR_DISPATCH &&
      !isInstallationInstructionEmailSend &&
      !getOrderDetailsLoading &&
      !expendProductListTable &&
      !orderDetails?.sent_mails?.installation_instruction &&
      USER_PERMISSIONS?.ADD ? (
        <div
          className="border mb-3 rounded-3 p-2"
          style={{ borderColor: "#FFB1B1", background: "#FFE4E4" }}
        >
          <div className="d-flex row-gap-2 flex-wrap justify-content-between align-items-md-center">
            <div className="col-md-auto col-11 order-md-1 order-1">
              <h4 className="mb-0 fs-5 mob-fs-5 fw-semibold ">
                Installation Instruction Email Send to Client/Distributor
              </h4>
            </div>
            <div className="col-md-auto col-12 order-md-2 order-3 ms-auto">
              <button
                className="btn btn-primary"
                onClick={() => {
                  setIsSendMail(true);
                  // dispatch(sendConfirmReadyMailToClient())
                }}
              >
                SEND MAIL
              </button>
            </div>
            <div className="col-md-auto col-1 order-md-3 order-2 text-end">
              <span role="button">
                <span
                  className="svg-24 cursor-pointer ms-2"
                  onClick={() => {
                    setIsInstallationInstructionEmailSend(true);
                  }}
                >
                  {svg?.closeRedIcon}
                </span>
              </span>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      {/* <div className="row gy-3"> */}
      <div
        className={` ${
          isProductionPlanningTab || isModifyDispatchPlaning
            ? "row gy-3 h-100"
            : ""
        }`}
      >
        {/* Sidebar (Matched Col-2 + Tabs Component) */}
        <div className="col-12">
          <div className="row gy-3 h-100">
            {/* Sidebar */}
            <div
              className={`col-lg-2 ${
                isProductionPlanningTab || isModifyDispatchPlaning
                  ? "d-none"
                  : ""
              }`}
            >
              <div className="customTabs create-quotation-tabs bg-white border-0 shadow rounded-3">
                {!screens.lg && (
                  <button
                    type="button"
                    className="quotation-mobile-nav-trigger"
                    onClick={() => setIsMobileNavOpen((prev) => !prev)}
                  >
                    <span className="quotation-mobile-nav-trigger-label">
                      {activeStep?.includes("__") ? (
                        <>
                          <span className="quotation-mobile-nav-trigger-meta">
                            {
                              STATIC_STORAGE_GROUPS.find(
                                (g) => g.key === activeStep?.split("__")[0],
                              )?.label
                            }
                          </span>
                          <span className="quotation-mobile-nav-trigger-title">
                            {
                              STATIC_GROUP_CHILDREN.find(
                                (c) => c.key === activeStep?.split("__")[1],
                              )?.label
                            }
                          </span>
                        </>
                      ) : (
                        <span className="quotation-mobile-nav-trigger-title">
                          {items?.find((i) => i?.key === activeStep)?.label}
                        </span>
                      )}
                    </span>
                    <span
                      className={`quotation-side-nav-group-arrow ${
                        isMobileNavOpen ? "is-expanded" : ""
                      }`}
                    >
                      {svg?.selectDownArrow}
                    </span>
                  </button>
                )}

                <div
                  className={`quotation-side-nav ${
                    !screens.lg && !isMobileNavOpen ? "d-none" : ""
                  }`}
                >
                  {/* Top static items e.g., Customer Details */}
                  {items.slice(0, 1).map(({ label, key }) => (
                    <button
                      key={key}
                      type="button"
                      className={`quotation-side-nav-item ${
                        activeStep === key ? "is-active" : ""
                      }`}
                      onClick={() => handleTabChange(key)}
                    >
                      {label}
                    </button>
                  ))}

                  {/* Dynamic Items */}
                  {STATIC_STORAGE_GROUPS.map((group: StorageGroup) => {
                    const isExpanded = expandedGroups.includes(group.key);

                    return (
                      <div key={group.key} className="quotation-side-nav-group">
                        <button
                          type="button"
                          className="quotation-side-nav-group-header"
                          onClick={() => toggleGroup(group.key)}
                        >
                          <div className="quotation-side-nav-group-media">
                            <img
                              src={
                                group?.image
                                  ? getFullAwsUrl(group?.image, true)
                                  : DefaultNoImageFound
                              }
                              alt={group.label}
                              className="quotation-side-nav-group-image"
                            />
                            <span className="quotation-side-nav-group-title">
                              {group.label}
                            </span>
                          </div>

                          <span
                            className={`quotation-side-nav-group-arrow ${
                              isExpanded ? "is-expanded" : ""
                            }`}
                          >
                            {svg?.selectDownArrow}
                          </span>
                        </button>

                        {isExpanded && (
                          <div className="quotation-side-nav-group-children">
                            {getChildrenForCategory(group)
                              .filter((child) => {
                                if (
                                  child.key === CreateQuotationStepsEnum.SUMMARY
                                ) {
                                  return CategoriesSlugWithSummaries.includes(
                                    (group.slug || "") as CategorySlugs,
                                  );
                                }
                                return true;
                              })
                              .map((child) => {
                                const childKey = getStaticNestedStepKey(
                                  group.key,
                                  child.key,
                                );
                                return (
                                  <button
                                    key={`${group.key}-${child.key}`}
                                    type="button"
                                    className={`quotation-side-nav-group-child ${
                                      activeStep === childKey ? "is-active" : ""
                                    }`}
                                    onClick={() => handleTabChange(childKey)}
                                  >
                                    {child.label}
                                  </button>
                                );
                              })}
                          </div>
                        )}
                      </div>
                    );
                  })}

                  {/* Bottom static items */}
                  {items.slice(1).map(({ label, key }) => (
                    <button
                      key={key}
                      type="button"
                      className={`quotation-side-nav-item ${
                        activeStep === key ? "is-active" : ""
                      }`}
                      onClick={() => handleTabChange(key)}
                    >
                      {label}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            {/* Content */}
            <div
              className={`mobile-font-s ${
                isProductionPlanningTab || isModifyDispatchPlaning
                  ? "col-lg-12 h-100"
                  : "col-lg-10"
              }`}
            >
              {getOrderDetailsLoading ? (
                isProductionPlanningTab || isModifyDispatchPlaning ? (
                  <div
                    className="w-100 d-flex align-items-center justify-content-center"
                    style={{ height: "calc(100vh - 12rem)" }}
                  >
                    <FullScreenLoader />
                  </div>
                ) : (
                  <Skeleton active paragraph={{ rows: 6 }} />
                )
              ) : (
                activeComponent
              )}
            </div>
          </div>
        </div>
      </div>
      {isChangeStatus && (
        <StatusChangeConfirmationModal
          visible={isChangeStatus ? true : false}
          setIsModalVisible={setIsChangeStatus}
          statusData={isChangeStatus}
          setIsStatusUpdateError={setIsStatusUpdateError}
          setStatusErrorData={setStatusErrorData}
        />
      )}
      {isStatusUpdateError &&
        isStatusUpdateError !== "DROP_TBC_ERROR" &&
        isStatusUpdateError !== "VARIABLE_CONFIRMATION_REQUIRED" && (
          <PlaningStatusErrorModal
            visible={isStatusUpdateError}
            setIsModalVisible={setIsStatusUpdateError}
            buttonText={
              isStatusUpdateError == "load_notice_not_printed"
                ? "CLOSE"
                : "UPDATE"
            }
            title={
              isStatusUpdateError == "production_not_completed"
                ? "Please Complete Production Status of All Departments"
                : isStatusUpdateError == "installation_not_completed"
                ? "Order Cannot Be Closed!"
                : isStatusUpdateError == "insufficient_lean_product_stock"
                ? "Insufficient Product Stock!"
                : isStatusUpdateError == "load_notice_not_printed"
                ? "Load Notice Not Printed"
                : "Please Add Production Planning Details"
            }
            description={
              isStatusUpdateError == "insufficient_lean_product_stock" ? (
                <span>
                  Insufficient stock for &quot;
                  {statusErrorData?.product_name || "Product"}&quot; in Off
                  Shelf Product Inventory. <br />
                  <strong
                    className="fw-bold text-dark"
                    style={{ fontWeight: 700 }}
                  >
                    Current stock: {statusErrorData?.current_stock ?? 0},
                    Required: {statusErrorData?.required_qty ?? 0}
                  </strong>
                </span>
              ) : isStatusUpdateError === "production_not_completed"
                ? "The order status cannot be updated until the production status for all departments has been completed."
                : isStatusUpdateError === "installation_not_completed"
                ? "The order cannot be marked as closed because the installation status has not been updated. Please complete the installation plan to proceed."
                : isStatusUpdateError === "load_notice_not_printed"
                ? 'You cannot change the order status to "Ready for Dispatch" until the load notice has been printed. Please ask the Printing Team to print the load notice, then try again.'
                : "You must complete the production planning information to proceed. Status cannot be updated until all required details are filled."
            }
            setSearchParams={setSearchParams}
            handleRedirect={() => {
              if (isStatusUpdateError == "insufficient_lean_product_stock") {
                navigate("/off-self-products");
              } else if (isStatusUpdateError == "installation_not_completed") {
                navigate(`/installation-plan/${statusErrorData?._id}`, {
                  state: {
                    backPath: `${location?.pathname}${location?.search}`,
                  },
                });
              } else if (isStatusUpdateError == "load_notice_not_printed") {
                // Modal closes via setIsStatusUpdateError(null) below
              } else if (isStatusUpdateError == "production_not_completed") {
                const orderDisplay = orderIdToDisplay || orderDetails?.order_id || "";
                navigate(
                  `/production-plan?order_id=${orderDetails?._id || id}${
                    orderDisplay ? `&order_number=${encodeURIComponent(orderDisplay)}` : ""
                  }`,
                );
              } else {
                if (location?.search != "?tab=production-planning") {
                  setSearchParams({ tab: "production-planning" });
                }
              }
              setIsStatusUpdateError(null);
              setStatusErrorData(null);
            }}
          />
        )}
      {isStatusUpdateError === "DROP_TBC_ERROR" && (
        <DropTbcWarningModal
          open={true}
          onClose={() => setIsStatusUpdateError(null)}
          onUpdate={() => {
            const sectionId =
              statusErrorData?.drop_tbc_warnings?.redirect_section_id;
            console.log("Section Id", sectionId);
            console.log("Status Error Data", statusErrorData);

            if (sectionId) {
              setSearchParams({ tab: sectionId });
            }
            setIsStatusUpdateError(null);
            setStatusErrorData(null);
          }}
        />
      )}
      {!orderDetails?.is_2bs_order &&
        isStatusUpdateError === "VARIABLE_CONFIRMATION_REQUIRED" &&
        bomVariableWarnings.parts.length +
          bomVariableWarnings.components.length >
          1 && (
          <VariableConfirmationModal
            open={true}
            orderId={id || orderDetails?._id}
            onClose={() => setIsStatusUpdateError(null)}
            onConfirm={(localWarnings) => {
              handleConfirmVariableWarnings(localWarnings);
              setIsStatusUpdateError(null);
            }}
            loading={isConfirmingVariable}
            warnings={bomVariableWarnings}
            possibleBomDimensions={possibleBomDimensions}
          />
        )}
      {isChangeOrderNumber && (
        <ChangeOrderNumber
          visible={isChangeOrderNumber}
          setIsModalVisible={setIsChangeOrderNumber}
          order_id={orderDetails?.order_id}
        />
      )}
      {isSendMail && (
        <SendMailConfirmationModal
          visible={isSendMail}
          setIsModalVisible={setIsSendMail}
        />
      )}
      <CommonConfirmationModal
        open={showUnsavedModal}
        title="Unsaved Changes"
        subTitle="You have unsaved changes in Installation Checklist. Leaving will discard your edits. Are you sure you want to proceed?"
        confirmButtonText="LEAVE WITHOUT SAVING"
        confirmButtonColorClass="btn-red"
        onClose={() => {
          setShowUnsavedModal(false);
          setPendingTabKey(null);
        }}
        onSuccess={() => {
          setShowUnsavedModal(false);
          setIsChecklistEditing(false);
          setChecklistResetKey((prev) => prev + 1);
          if (pendingTabKey) {
            setSearchParams({ tab: pendingTabKey });
            setPendingTabKey(null);
          }
        }}
      />
      {isAccountsApprovalModalVisible && (
        <AccountsApprovalModal
          visible={isAccountsApprovalModalVisible}
          onClose={() => setIsAccountsApprovalModalVisible(false)}
          orderData={orderDetails}
          onSuccess={() => {
            if (id) {
              dispatch(GetOrdersDetailsAPI({ order_id: id }));
            }
          }}
        />
      )}
    </div>
  ) : authLoading ? (
    <FullScreenLoader />
  ) : (
    <NoPermissionPage />
  );
};

export default OrderDetails;
